(function () {
  var WISHLIST_KEY = 'keizers_wishlist';
  var RECENTLY_VIEWED_KEY = 'keizers_recently_viewed';

  function readStorage(key) {
    try {
      return JSON.parse(localStorage.getItem(key)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  function toggleWishlist(item) {
    var items = readStorage(WISHLIST_KEY);
    var exists = items.some(function (entry) {
      return String(entry.id) === String(item.id);
    });

    if (exists) {
      items = items.filter(function (entry) {
        return String(entry.id) !== String(item.id);
      });
    } else {
      items.unshift(item);
    }

    writeStorage(WISHLIST_KEY, items);
    updateWishlistButtons();
    renderWishlistPage();
  }

  function updateWishlistButtons() {
    var items = readStorage(WISHLIST_KEY);
    var ids = items.map(function (item) { return String(item.id); });

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var id = String(button.getAttribute('data-product-id'));
      var active = ids.indexOf(id) > -1;
      button.classList.toggle('is-active', active);

      var icon = button.querySelector('.ce-wishlist-button__icon');
      if (icon) {
        icon.textContent = active ? '♥' : '♡';
      }
    });
  }

  function bindWishlistButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        toggleWishlist({
          id: button.getAttribute('data-product-id'),
          handle: button.getAttribute('data-product-handle'),
          url: button.getAttribute('data-product-url'),
          title: button.getAttribute('data-product-title'),
          price: button.getAttribute('data-product-price'),
          comparePrice: button.getAttribute('data-product-compare-price'),
          image: button.getAttribute('data-product-image')
        });
      });
    });
  }

  function trackRecentlyViewedCards() {
    document.querySelectorAll('[data-product-id]').forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      var titleNode = card.querySelector('.ce-card__title, .ce-mini-card__title');
      var imageNode = card.querySelector('img');
      var href = card.getAttribute('href');

      if (!id || !titleNode || !href) return;

      var data = {
        id: id,
        url: href,
        title: titleNode.textContent.trim(),
        image: imageNode ? imageNode.src : ''
      };

      var current = readStorage(RECENTLY_VIEWED_KEY).filter(function (item) {
        return String(item.id) !== String(id);
      });

      current.unshift(data);
      current = current.slice(0, 12);
      writeStorage(RECENTLY_VIEWED_KEY, current);
    });
  }

  function renderRecentlyViewed() {
    document.querySelectorAll('[data-recently-viewed]').forEach(function (wrapper) {
      var maxProducts = parseInt(wrapper.getAttribute('data-max-products') || '4', 10);
      var grid = wrapper.querySelector('.ce-recently-viewed__grid');
      if (!grid) return;

      var items = readStorage(RECENTLY_VIEWED_KEY).slice(0, maxProducts);

      if (!items.length) {
        wrapper.style.display = 'none';
        return;
      }

      grid.innerHTML = items.map(function (item) {
        return ''
          + '<a class="ce-recent-card" href="' + item.url + '">'
          +   '<div class="ce-recent-card__media">'
          +     (item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '')
          +   '</div>'
          +   '<div class="ce-recent-card__body">'
          +     '<h3>' + item.title + '</h3>'
          +   '</div>'
          + '</a>';
      }).join('');
    });
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    var items = readStorage(WISHLIST_KEY);

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.classList.remove('hidden');
      return;
    }

    if (empty) empty.classList.add('hidden');

    grid.innerHTML = items.map(function (item) {
      return ''
        + '<a class="ce-wishlist-card" href="' + item.url + '">'
        +   '<div class="ce-wishlist-card__media">'
        +     (item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '')
        +   '</div>'
        +   '<div class="ce-wishlist-card__body">'
        +     '<h3>' + item.title + '</h3>'
        +     (item.comparePrice ? '<div class="ce-wishlist-card__compare"><span>Adviesprijs</span> ' + item.comparePrice + '</div>' : '')
        +     (item.price ? '<div class="ce-wishlist-card__price">' + item.price + '</div>' : '')
        +   '</div>'
        + '</a>';
    }).join('');
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindWishlistButtons();
    updateWishlistButtons();
    trackRecentlyViewedCards();
    renderRecentlyViewed();
    renderWishlistPage();
  });
})();